/**
 * Nike / brand rows for a material slug.
 * Includes exact matches and related variants whose slug ends with `-{slug}`
 * (e.g. antique-rave → kid-antique-rave, slot-antique-rave).
 */
export function getBrandDataForSlug(nikeData, slug) {
  if (!slug || !Array.isArray(nikeData)) {
    return [];
  }

  const needle = String(slug).trim().toLowerCase();
  if (!needle) {
    return [];
  }

  return nikeData.filter((item) => {
    const itemSlug = String(item?.slug || "")
      .trim()
      .toLowerCase();
    return itemSlug === needle || itemSlug.endsWith(`-${needle}`);
  });
}

export function formatBrandMaterialName(item, fallbackTitle = "") {
  const name = String(item?.pdm_material_name || fallbackTitle || "").trim();
  return name.toUpperCase();
}
